import React from "react";
import RequestEngine from "../../core/RequestEngine";
import strings from "../../core/translate";
import { apiErrorMessage } from "../../shared/api-error";
import {
  FormSection,
  FormGrid,
  TextField,
  SelectField,
  SwitchField,
  FormAlert,
  FormActions,
} from "../../components/Form/FormKit";

// One way a car can arrive at a garage or leave it, e.g. "Recovery".
export default class DeliveryMethodForm extends React.Component {
  constructor(props) {
    super(props);
    const method = props.item || {};
    this.state = {
      id: method.id || "",
      version: method.version,
      name: method.name || "",
      sortOrder:
        method.sortOrder === undefined || method.sortOrder === null
          ? ""
          : `${method.sortOrder}`,
      isActive: method.id ? !!method.isActive : true,
      details: method.details || "none",
      loading: false,
      error: "",
      errors: {},
    };
    this.engine = new RequestEngine();
  }

  validate() {
    const errors = {};
    if (`${this.state.name}`.trim().length < 2) {
      errors.name = strings.name_min_hint;
    }
    return errors;
  }

  handleSubmit = async (event) => {
    event.preventDefault();

    const errors = this.validate();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    const { id, version, name, sortOrder, isActive, details } = this.state;
    this.setState({ loading: true, error: "", errors: {} });

    const order = parseInt(sortOrder, 10);
    const payload = {
      name: `${name}`.trim(),
      sortOrder: Number.isNaN(order) ? 0 : order,
      isActive,
      details,
    };

    try {
      const response = id
        ? await this.engine.updateItem("delivery-methods", id, {
            ...payload,
            version,
          })
        : await this.engine.saveItem("delivery-methods", payload);

      if (response && (response.status === 200 || response.status === 201)) {
        this.setState({ loading: false });
        this.props.onSaved(response.data);
        return;
      }
    } catch (err) {
      this.setState({ error: apiErrorMessage(err) });
    }
    this.setState({ loading: false });
  };

  render() {
    const { name, sortOrder, isActive, details, loading, error, errors } =
      this.state;

    return (
      <form className="mform" onSubmit={this.handleSubmit}>
        <FormSection
          title={strings.delivery_method}
          icon="nc-icon nc-delivery-fast"
        >
          <FormGrid>
            <TextField
              label={strings.name}
              required
              help={strings.delivery_method_name_hint}
              value={name}
              onChange={(value) => this.setState({ name: value })}
              error={errors.name}
            />
            <TextField
              label={strings.display_order}
              type="number"
              step="1"
              help={strings.display_order_hint}
              value={sortOrder}
              onChange={(value) => this.setState({ sortOrder: value })}
            />
          </FormGrid>

          <FormGrid full>
            <SelectField
              label={strings.delivery_method_asks_for}
              value={details}
              options={[
                { value: "none", label: strings.asks_nothing },
                { value: "person", label: strings.asks_person },
                { value: "company", label: strings.asks_company },
              ]}
              onChange={(value) => this.setState({ details: value })}
              help={strings.delivery_method_asks_for_hint}
            />
          </FormGrid>

          <SwitchField
            label={strings.active}
            help={strings.delivery_method_active_hint}
            checked={isActive}
            onChange={(checked) => this.setState({ isActive: checked })}
          />
        </FormSection>

        <FormAlert>{error}</FormAlert>
        <FormActions onCancel={this.props.onCancel} loading={loading} />
      </form>
    );
  }
}
